import Layout from '../../layout/index'

const aboutRouter = {
  path: '/about',
  component: Layout,
  redirect: '/about/single',
  children: [
    {
      path: 'single',
      name: 'aboutSingle',
      component: () => import('../../views/about/single')
    }
  ]
}
export default aboutRouter
